module.exports = __webpack_public_path__ + "img/logo-cvpc.4c236f0a.png";